import { environment } from '@envs/environment';

export function getRoutePath(url: string): string {
  if (!checkIfItLocalRoute(url)) {
    return url;
  }
  const marker = '/#/';
  const markerIndex = url.indexOf(marker);

  if (markerIndex !== -1) {
    return url.substring(markerIndex + marker.length - 1);
  }

  try {
    const parsedUrl = new URL(url);
    return parsedUrl.pathname;
  } catch {
    return '';
  }
}

export const checkIfItLocalRoute = (url: string) => {
  return url.includes(environment.localDomain);
};
